import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles';

interface Props {
  title1: string;
  title2?: string;
}

const PageTitleWrapper = styled.div`
  width: 100%;
  padding: 2rem 0;
  text-align: center;

  .title-1,
  .title-2 {
    margin: 0;
    line-height: 1;
    color: ${colors.text};
  }
  .title-1 {
    margin-bottom: 0.8125rem;
    letter-spacing: -0.02em;
  }
  .title-2 {
    font-weight: normal;
    font-size: 0.8125rem;
  }
`;

export default class PageTitle extends React.Component<any, {}> {
  render() {
    const { title1, title2 } = this.props;

    return (
      <PageTitleWrapper>
        <h2 className="title-1">{title1}</h2>
        {title2 ? <h5 className="title-2">{title2}</h5> : null}
      </PageTitleWrapper>
    );
  }
}
